// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__2Hcu_","logo":"header_logo__1TRCu"};